import { Component, OnInit } from "@angular/core";

import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { BeneficiaryUsageIndicatorData } from "src/app/ui/models/domains/pbm/indicators/beneficiary-usage-data";
import { BeneficiaryUsageIndicatorDataStrategy } from "src/app/ui/pages/home/indicator-data-strategies";
import { IndicatorMediator } from "src/app/ui/services/pbm/indicator-mediator";
import { IndicatorService } from "src/app/ui/services/pbm/indicator.service";

@Component({
  selector: "beneficiary-usage-indicator",
  templateUrl: "./beneficiary-usage-indicator.component.html",
  styleUrls: ["./beneficiary-usage-indicator.component.scss"],
})
export class BeneficiaryUsageIndicatorComponent implements OnInit {
  public beneficiaryUsageData: BeneficiaryUsageIndicatorData;
  public companyName: string;
  public isLoading: boolean = true;

  constructor(private indicatorService: IndicatorService, private indicatorMediator: IndicatorMediator) {}

  async ngOnInit() {
    this.beneficiaryUsageData = (await this.indicatorMediator.getIndicatorData(new BeneficiaryUsageIndicatorDataStrategy())) as BeneficiaryUsageIndicatorData;
    this.isLoading = false;
  }

  public async onFilterData(company: Company) {
    this.isLoading = true;
    if (company) this.beneficiaryUsageData = await this.indicatorService.getBeneficiaryUsageData([company.getFiscalNumber()]);
    else this.beneficiaryUsageData = await this.indicatorService.getBeneficiaryUsageData();
    this.isLoading = false;
  }

  public beneficiaryUsageDataValue(): number {
    return Number(this.beneficiaryUsageData.getUsagePercentage());
  }

  public beneficiaryUsageTotalValue(): string {
    return this.beneficiaryUsageData && this.beneficiaryUsageData.getTotal();
  }
}
